"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var defaultTableTheme_1 = tslib_1.__importDefault(require("./defaultTableTheme"));
var TableThemeContext = react_1.default.createContext(defaultTableTheme_1.default);
var TableThemeProvider = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? {} : _b, children = _a.children;
    var combinedTheme = react_1.useMemo(function () { return (tslib_1.__assign(tslib_1.__assign({}, defaultTableTheme_1.default), theme)); }, [
        theme
    ]);
    return (react_1.default.createElement(TableThemeContext.Provider, { value: combinedTheme }, children));
};
exports.TableThemeProvider = TableThemeProvider;
var useTableTheme = function () { var _a; return (_a = react_1.useContext(TableThemeContext)) !== null && _a !== void 0 ? _a : defaultTableTheme_1.default; };
exports.useTableTheme = useTableTheme;
var withTableTheme = function (Component, styleKey) {
    var StyledComponent = function (props) {
        var theme = useTableTheme();
        var stylesToApply = theme[styleKey];
        var MemoizedStyledComponent = react_1.useMemo(function () { return core_1.styled(Component)(stylesToApply); }, [stylesToApply, Component]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return react_1.default.createElement(MemoizedStyledComponent, tslib_1.__assign({}, props));
    };
    StyledComponent.displayName = "Styled" + Component.displayName;
    StyledComponent.propTypes = Component.propTypes;
    StyledComponent.defaultProps = Component.defaultProps;
    return StyledComponent;
};
exports.withTableTheme = withTableTheme;
TableThemeProvider.propTypes = {
    theme: prop_types_1.default.any
};
